<template>
  <div>
    <FieldsetHeroModule :data="templateEntry" />

    <ProductSearch :category="category.value" />

    <LoaderComponents :components="templateEntry?.main_components" />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  category: {
    type: Object,
    default: () => ({}),
  },
})

// Provide isHero to FieldsetHeroModule to render a h1 instead of h2
provide('isHero', true)

const { locale } = useI18n()
const templateEntry = computed(() => {
  return data.value?.entry
})

// Fetch the product template page from statamic
const slug = getTemplatePageSlug(props.category.value?.breadcrumb?.[1])

const { data, error } = await useAsyncGql('ProductTemplate', {
  slug: slug,
  site: locale.value,
  status: '(draft|expired|scheduled|published)', // Fetch all status
})

if (error.value) {
  useGqlError((err) => {
    // Only log during development
    if (process.env.NODE_ENV === 'production') return

    // throw graphql errors when they exist
    if (err.gqlErrors && err.gqlErrors.length) {
      throw createError({
        statusCode: 500,
        statusMessage: 'GraphQL Error',
        message: err.gqlErrors[0].message,
        data: err.gqlErrors[0],
      })
    }

    class FetchError extends Error {
      constructor(
        message: string,
        public status: number,
        public cause?: Error,
      ) {
        super(message)
      }
    }

    throw new FetchError('Could not fetch template page (initial)', 500, error.value)
  })
}

if (!data.value || !data.value.entry) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Entry not found',
    message: 'No entry found as template for the product overview pages',
  })
}

useSeotamic(ref(data.value.entry))

function getTemplatePageSlug(categoryName: string) {
  switch (categoryName) {
    case 'Chemie':
      return 'produkt-filter-vorlage-chemie'
    case 'Geräte&Verbrauchsmaterial':
      return 'produkt-filter-vorlage-geraete-und-verbrauchsmaterial'
    default:
      return 'produkt-filter-vorlage-standard'
  }
}
</script>
